import { HttpErrorResponse } from "@angular/common/http";
import { ErrorData, OptionValues } from "../_models/common-dto";
import { DataGridRequest } from "../_models/datagrid";
import * as constant from 'src/app/_helpers/constant';
import * as dayjs from 'dayjs';
import { hashSync, genSaltSync } from "bcryptjs";
import 'dayjs/locale/id'

dayjs.locale('id');
const saltRounds = 10;

export const Trait = {
    OptDefault(): OptionValues {
        return {code: '-1', name: '---'}
    },

    HashText(param: string): string {
        const salt = genSaltSync(saltRounds);
        return hashSync(param, salt);
    },

    ErrorResponse(err: HttpErrorResponse): ErrorData {
        switch (err.status) {
            case 400:
                let _400: ErrorData = {
                    title: err.error.errors[0].title,
                    detail: err.error.errors[0].detail,
                    hint: constant.RESPONSE.HINT_400
                }
                return _400
                break;
            case 403:
                let _403: ErrorData = {
                    title: constant.RESPONSE.ERROR_403,
                    detail: constant.RESPONSE.HINT_403,
                    hint: err.error.message
                }
                return _403
                break;
            case 413:
                let _413: ErrorData = {
                    title: constant.RESPONSE.ERROR_413,
                    detail: constant.RESPONSE.HINT_413,
                    hint: err.error.message
                }
                return _413
                break;
            case 422:
                let _422: ErrorData = {
                    title: err.statusText,
                    detail: err.error.message ?? err.error.errors,
                    hint: constant.RESPONSE.HINT_422
                }
                return _422
                break;
            default:
                let _500: ErrorData = {
                    title: (err.error.errors !== undefined) ? err.error.errors[0].title : err.error.message,
                    detail: (err.error.errors !== undefined) ? this.ErrorHint(err.error.errors[0].detail)[0] : err.error.exception,
                    hint: (err.error.errors !== undefined) ? this.ErrorHint(err.error.errors[0].detail)[1] : err.error.file + " line " + err.error.line
                }
                return _500
                break;
        }
    },

    ErrorHint(err: string): any {
        if (err.includes('[Galat]')) {
            let params = err.split('[Galat]');
            return [params[0], params[1]];
        } else {
            return [err, '']
        }
    },

    PageOffset(offset: number, limit: number): number {
        let result = (offset + 2) / limit;
        return Math.round(result) + 1;
    },

    SingleSortOrder(order: string): string {
        return order === "desc" ? "-" : ""
    },

    RequestParams(payload: DataGridRequest): string {
        let singleFilter = ''
        let arrayFilter = ''
        if (payload.filters.length > 0) {
            payload.filters.forEach(el => {
                if (!el.arr && el.val !== undefined && el.val !== 'all' && el.val !== '') {
                    singleFilter += '&filter['+el.key+']='+el.val
                }
                if (el.arr && el.val !== undefined && el.val !== 'all' && el.val !== '') {
                    arrayFilter += '&filter['+el.key+'][]='+el.val
                }
            });
        }
        return '?page[number]='+payload.offset+'&page[size]='+payload.limit+'&sort='+this.SingleSortOrder(payload.sortOrder)+payload.sortField+singleFilter+arrayFilter;
    },

    RoleName(name: string): string {
        if (name.includes('_')) {
            let names = name.split('_')
            for (let i = 0; i < names.length; i++) {
                names[i] = names[i][0].toUpperCase() + names[i].substring(1)
            }
            return names.join(' ')
        } else {
            return name[0].toUpperCase() + name.substring(1)
        }
    },

    RoleActionId(name: string): string {
        let names = name.split('-');
        return names[0]
    },

    RoleActionName(name: string): string {
        let names = name.split('-');
        switch (names[1]) {
            case 'show':
                return 'Lihat';
                break;
            case 'store':
                return 'Tambah';
                break;
            case 'update':
                return 'Ubah';
                break;
            case 'destroy':
                return 'Hapus';
                break;
            case 'bulkUpdate':
                return 'Ubah Masal';
                break;
            case 'bulkDelete':
                return 'Hapus Masal';
                break;
            case 'relProduct':
                return 'Relasi Produk';
                break;
            case 'relProductDestroy':
                return 'Relasi Produk Hapus';
                break;
            case 'bclktGenerate':
                return 'Generate BCLKT';
                break;
            case 'bclktReportGenerate':
                return 'Generate Laporan BCLKT';
                break;
            case 'rollback':
                return 'Rollback';
                break;
            case 'dueDateExtend':
                return 'Perpanjang Jatuh Tempo';
                break;
            case 'toExcel':
                return 'Export Excel';
                break;
            case 'exception':
                return 'Kecualikan';
                break;
            case 'bclGet':
                return 'Pemilihan PEB';
                break;
            case 'exclude':
                return 'Kecualikan PEB';
                break;
            case 'cancel':
                return 'Batalkan';
                break;
            case 'pibFind':
                return 'Cari PIB';
                break;
            case 'pibCancel':
                return 'Batalkan PIB';
                break;
            case 'groupUpdate':
                return 'Ubah Grup';
                break;
            case 'ssoAdd':
                return 'Tambah EMS SSO';
                break;
            case 'list':
                return 'Lihat daftar';
                break;
            case 'getSource':
                return 'Ambil data sumber';
                break;
            case 'syncTarget':
                return 'Sinkronkan target';
                break;
            default:
                return 'Akses menu'
                break;
        }
    },
    
    FilterArray(arr: Array<string>, filter: string) {
        let result = []
        for (let index:number = 0; index < arr.length; index++) {
            if (arr[index]['key' as any] != filter) {
                result.push({key: arr[index]['key' as any], value: arr[index]['value' as any]})
            }
        }
        return result
    },

    GetArrayValueByKey(arr: Array<any>, key: string | any, find: string | any, val: string | any) {
        let result: any
        for (let index = 0; index < arr.length; index++) {
            if (arr[index][key] === find) {
                result = arr[index][val]
            }
        }
        return result
    },
    
    PopulateList(param: Array<string>) {
        let el = '<ul class="m-0">'
        for (let index = 0; index < param.length; index++) {
            el += '<li>'+param[index]+'</li>'
        }
        el += '</ul>'
        return el
    },

    GetSplitIndex(param: string, delimiter: string, index: number) {
        let values = param.split(delimiter)
        return values[index]
    },

    CommaSeparateNumber(val:number) {
        var sign = 1;
        if (val < 0) {
            sign = -1;
            val = -val;
        }
        let num = val.toString().includes('.') ? val.toString().split('.')[0] : val.toString()
        while (/(\d+)(\d{3})/.test(num.toString())) {
            num = num.toString().replace(/(\d+)(\d{3})/, '$1' + ',' + '$2')
        }
        if (val.toString().includes('.')) {
            num = num + '.' + val.toString().split('.')[1]
        }
        return sign < 0 ? '-' + num : num
    },

    CurrencyFormat(val: number) {
        var sign = 1;
        if (val < 0) {
            sign = -1;
            val = -val;
        }
        let num = val.toString().includes('.') ? val.toString().split('.')[0] : val.toString()
        while (/(\d+)(\d{3})/.test(num.toString())) {
            num = num.toString().replace(/(\d+)(\d{3})/, '$1' + '.' + '$2')
        }
        if (val.toString().includes('.')) {
            num = num + ',' + val.toString().split('.')[1]
        }
        return sign < 0 ? '-' + num : num
    },

    StringToFloat(val: string) {
        return parseFloat(val.replace(/[&\/\\#,+()$~%'":*?<>{}]/g,''))
    },

    RemoveCurrencyFormat(val: string) {
        let param = val.slice(2)
        return parseFloat(param.replace(/[&\/\\#,+()$~%'":*?<>{}]/g,''))
    },

    ParseCurrencyFormat(val: string) {
        let param = val.slice(2).split(',')
        let value = param[0].replace(/[&\/\\#.+()$~%'":*?<>{}]/g, '')
        return parseFloat(value + '.' + param[1])
    },

    ParseDecimalFormat(val: string) {
        let param = val.split(',')
        let value = param[0].replace(/[&\/\\#.+()$~%'":*?<>{}]/g, '')
        return parseFloat(value + '.' + param[1])
    },

    RandomString(length: number) {
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'
        let result = ''
        for ( let i = 0; i < length; i++ ) {
            result += characters.charAt(Math.floor(Math.random() * characters.length));
        }
        return result
    },

    SumArray(param: Array<number>) {
        let sum = 0
        for (let i = 0; i < param.length; i += 1) {
            sum += param[i]
        }
        return sum
    },

    TruncateText(text:string, maxLength:number) {
        if (text.length > maxLength) {
            text = text.substring(0,maxLength) + '...'
        }
        return text
    },

    FormatDate(date: Date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();
        if (month.length < 2) 
            month = '0' + month;
        if (day.length < 2) 
            day = '0' + day;
        return [year, month, day].join('-');
    },

    StringToDateFormat(param: string): string {
        return dayjs(param).format("DD/MM/YYYY").toString();
    },

    ObjectToQuery(param: any): string {
        let s = "";
        for (let key in param) {
            if (s != "") {
                s += "&";
            }
            s += (key + "=" + encodeURIComponent(param[key]));
        }
        return s;
    },

    FormatCategory(param: string): string {
        let result = ""
        let payload = param.split("_")
        for (let i = 0; i < payload.length; i++) {
            const capitalized = payload[i].charAt(0).toUpperCase() + payload[i].slice(1) + " "
            result += capitalized
        }
        return result.slice(0, -1)
    },

    FormatCategoryOpt(param: string): string {
        let result = ""
        let payload = param.split(" ")
        for (let index = 0; index < payload.length - 1; index++) {
            result = payload.join("_").toLowerCase()
        }
        return result.slice(0, -1)
    },

    ParseDate(param: string): Date {
        if (this.IsDateValid(param)) {
            return new Date(param)
        } else {
            let params = param.split("/")
            return new Date(params[2]+"-"+params[1]+"-"+params[0])
        }
    },

    ParseDateSql(param: string): Date {
        let params = param.split("/")
        return new Date(params[2]+"-"+params[1]+"-"+params[0])
    },

    ParseDateTimeSql(param: string): Date {
        let times = param.split(" ")
        let params = times[0].split("/")
        return new Date(params[2]+"-"+params[1]+"-"+params[0]+" " + times[1])
    },

    IsDateValid(param: string) {
        let dateObj = new Date(param);
        return !isNaN(dateObj.getTime())
    },

    CalculateDueDate(day: number, param: Date) {
        let dueDate = new Date(param);
        dueDate.setDate(dueDate.getDate() - day);
        return dueDate;
    },

    DateToString(param: Date, isFormat: boolean = true): string {
        return isFormat ? dayjs(param).format("DD/MM/YYYY").toString() : dayjs(param).format("YYYYMMDD").toString();
    },

    DateToStringSql(param: Date): string {
        return dayjs(param).format("YYYY-MM-DD").toString();
    },

    BCLType(param: string): string {
        return param === 'Pembebasan' ? 'exemption' : 'drawback'
    },

    ToLocalDate(param: string): string {
        return dayjs(this.ParseDateSql(param)).format("dddd, DD/MM/YYYY")
    },

    Miliseconds(): number {
        return new Date().getTime()
    },

    EnumPeriod(param: string): string {
        return param === 'daily' ? 'Harian' : param === 'weekly' ? 'Mingguan' : param === 'monthly' ? 'Bulanan' : param === 'yearly' ? 'Tahunan' : ''
    },

    RandomNumber(): number {
        return Math.floor(Math.random() * 1000000000000)
    },

    IsValidJSON(str: string): boolean {
        try {
            JSON.parse(str)
            return true 
        } catch (e) {
            return false 
        }
    },

    checkImageExists(imageUrl: string) {
        return new Promise((resolve) => {
            const img = new Image()
            img.onload = () => resolve(true)
            img.onerror = () => resolve(false)
            img.src = imageUrl
        })
    },
    

}

export const IsNotNullable = <T>(element: T | null | undefined): element is T =>
    typeof element !== "undefined" && element !== null;












